var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessionListLabel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    rx: 12,
    fill: "#343843"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.875C19.1738 10.875 20.9375 9.11133 20.9375 6.9375C20.9375 4.76367 19.1738 3 17 3C14.8262 3 13.0625 4.76367 13.0625 6.9375C13.0625 9.11133 14.8262 10.875 17 10.875Z",
    fill: "#757A88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4783 17.586L22 16.3057V19.0001C22 20.1047 22.8954 21.0001 24 21.0001H30C31.1046 21.0001 32 20.1047 32 19.0001V16.3057L28.5217 17.586H25.4783Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.8914V15.8787L25.4783 17.1591H28.5217L32 15.8787V14.8914C32 13.7868 31.1046 12.8914 30 12.8914H24C22.8954 12.8914 22 13.7868 22 14.8914Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 13C29 12.4696 28.7893 11.9609 28.4142 11.5858C28.0391 11.2107 27.5304 11 27 11C26.4696 11 25.9609 11.2107 25.5858 11.5858C25.2107 11.9609 25 12.4696 25 13L25.795 13C25.795 12.6804 25.922 12.3739 26.148 12.148C26.3739 11.922 26.6804 11.795 27 11.795C27.3196 11.795 27.6261 11.922 27.852 12.148C28.078 12.3739 28.205 12.6804 28.205 13H29Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6995 12.1031C21.3893 12.4777 21.0892 13.807 21.0204 15.0006C20.9887 15.552 20.5523 16 20 16H11C10.4477 16 9.99676 15.5516 10.061 15.003C10.2639 13.2726 11.0183 11 13 11C14.3153 11 15.6082 11.4649 16.9231 11.499C16.9488 11.4997 16.9744 11.5 17 11.5C17.3911 11.5 18.1492 11.4388 18.6523 11.2208C18.8957 11.1153 19.1499 10.9985 19.415 11.005C21.0176 11.0439 22.1626 11.3045 22.8285 11.5709C23.1735 11.709 23.0569 12.001 22.6995 12.1031Z",
    fill: "#757A88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionListLabel);
export default __webpack_public_path__ + "static/media/profession_list_label.4fda0255e3841345b8a98c75b758a842.svg";
export { ForwardRef as ReactComponent };